const reported = new Set<string>();

export function reportError(error: Error | string, context?: Record<string, unknown>): void {
  const message = typeof error === 'string' ? error : error.message;
  const stack = typeof error === 'string' ? undefined : error.stack;

  // Deduplicate: don't report same error twice per session
  const key = `${message}:${stack?.slice(0, 100)}`;
  if (reported.has(key)) return;
  reported.add(key);

  // Fire-and-forget POST to backend
  fetch('/api/client-errors', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      message,
      stack,
      url: window.location.href,
      userAgent: navigator.userAgent,
      timestamp: new Date().toISOString(),
      ...context,
    }),
  }).catch(() => {}); // Never fail on error reporting
}

const MAX_PER_SESSIE = 25;

function alsTekst(waarde: unknown): string {
  if (waarde instanceof Error) return waarde.message;
  if (typeof waarde === 'string') return waarde;
  try {
    return JSON.stringify(waarde);
  } catch {
    return String(waarde);
  }
}

/**
 * #1652 — de meeste fouten in de app worden afgevangen en alleen naar
 * console.error geschreven (bv. "Failed to save event for new person"). Die
 * bereikten de server nooit: in 90 dagen productie stond er geen enkele
 * CLIENT_ERROR in error_logs, terwijl de 409 van #1641 vier keer stil bleef.
 * Dit stuurt ze mee via dezelfde melder (dedup per sessie, max 25).
 */
export function installConsoleErrorReporting(): void {
  // eslint-disable-next-line no-console -- bewust: dit omhult console.error zelf
  const origineel = console.error.bind(console);
  // eslint-disable-next-line no-console -- bewust: dit omhult console.error zelf
  console.error = (...args: unknown[]) => {
    origineel(...args);
    if (reported.size >= MAX_PER_SESSIE) return;
    const fout = args.find((a): a is Error => a instanceof Error);
    const tekst = args.map(alsTekst).join(' ').slice(0, 500);
    reportError(fout ? Object.assign(new Error(tekst), { stack: fout.stack }) : tekst, {
      bron: 'console.error',
    });
  };
}
